import { ContractsListSkeleton } from "@/components/pages/client/contract/contract-card-skeleton";
import ContractsCard from "@/components/pages/client/contract/contracts-card";
import { QuoteCTASection } from "@/components/sections/section-quote-cta";
import CardActions from "@/components/ui/card-actions-client";
import { Separator } from "@/components/ui/separator";
import { useAuth } from "@/contexts/auth-context";
import { getHistorico } from "@/services/clientAreaService";
import { ContratoCotacao } from "@/types/Contrato";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ContractsPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [contratos, setContratos] = useState<ContratoCotacao[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const cli_codigo = user.cli_codigo;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await getHistorico(cli_codigo);
        setContratos(data);
      } catch (error) {
        console.error("Erro ao carregar histórico:", error);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [cli_codigo]);
  return (
    <div className="py-6 sm:py-10 w-full max-w-7xl items-center mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-n-green mb-5">
        Contratos
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <div className="bg-white rounded-2xl shadow-sm p-5 sm:p-6 space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <h2 className="text-lg sm:text-xl font-semibold text-n-green">
                Seus contratos
              </h2>
            </div>

            <Separator />

            {isLoading && <ContractsListSkeleton count={3} />}
            {!isLoading && hasError && (
              <p className="text-sm text-red-500">
                Ocorreu um erro ao carregar seus contratos. Tente novamente mais
                tarde.
              </p>
            )}
            {!isLoading && !hasError && contratos.length === 0 && (
              <QuoteCTASection />
            )}
            {!isLoading &&
              !hasError &&
              contratos.length > 0 &&
              contratos.map((contrato, index) => (
                <ContractsCard
                  key={contrato.cve_codigo}
                  contrato={contrato}
                  separator={index !== contratos.length - 1}
                  onViewMore={() =>
                    navigate(
                      `/cliente/detalhes-contrato/${contrato.cve_codigo}`
                    )
                  }
                />
              ))}
          </div>
        </div>

        <div className="lg:col-span-4">
          <CardActions />
        </div>
      </div>
    </div>
  );
}
